module.exports = __webpack_public_path__ + "public/img/tiku_cbg2.fc0205d2.png";